module.exports = __webpack_public_path__ + "media/images/product/p_n-24599ef81e74adfc56fc0334f404bfd4.png";